import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { FloppyDisk } from '@phosphor-icons/react';

const CRITICAL_PARAMS = new Set([
    'phase_current_max', 'battery_current_max',
    'overcurrent_protect', 'undervoltage_cutoff',
    'overvoltage_cutoff', 'motor_temp_limit', 'controller_temp_limit'
]);

export default function TuningControls({
    paramGroups, params, setParams, connectionMode,
    requestWrite, writingParam, profileName, setProfileName,
    saveProfile, saving,
}) {
    return (
        <div className="space-y-4">
            {paramGroups.map(group => (
                <Card key={group.group} className="glass-card">
                    <CardContent className="p-4 space-y-3">
                        <h3 className="font-display text-sm text-primary">{group.label.toUpperCase()}</h3>
                        {group.params.map(pm => (
                            <div key={pm.id}>
                                <div className="flex justify-between text-xs mb-1">
                                    <span className="text-muted-foreground">{pm.label}</span>
                                    <div className="flex items-center gap-2">
                                        <span className="font-mono text-foreground">{params[pm.id] ?? pm.default} {pm.unit}</span>
                                        {connectionMode && (
                                            <button
                                                onClick={() => requestWrite(pm.id, params[pm.id] ?? pm.default, pm.label)}
                                                disabled={writingParam === pm.id}
                                                className={`text-[9px] px-1.5 py-0.5 rounded font-display transition-colors disabled:opacity-40 ${CRITICAL_PARAMS.has(pm.id) ? 'bg-plasma-red/10 text-plasma-red hover:bg-plasma-red/20' : 'bg-primary/10 text-primary hover:bg-primary/20'}`}
                                                data-testid={`write-${pm.id}`}>
                                                {writingParam === pm.id ? '...' : CRITICAL_PARAMS.has(pm.id) ? 'WRITE !' : 'WRITE'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <input type="range" min={pm.min} max={pm.max} step={pm.max > 10 ? 1 : 0.1}
                                    value={params[pm.id] ?? pm.default}
                                    onChange={e => setParams(p => ({ ...p, [pm.id]: Number(e.target.value) }))}
                                    className="w-full h-1.5 rounded-full appearance-none cursor-pointer"
                                    style={{ background: `linear-gradient(to right, #7A00FF ${((params[pm.id] ?? pm.default) - pm.min) / (pm.max - pm.min) * 100}%, rgba(255,255,255,0.1) 0%)` }}
                                    data-testid={`param-${pm.id}`} />
                            </div>
                        ))}
                    </CardContent>
                </Card>
            ))}
            <Card className="glass-card">
                <CardContent className="p-4">
                    <div className="flex gap-2">
                        <Input value={profileName} onChange={e => setProfileName(e.target.value)} placeholder="Profile name..." className="flex-1" data-testid="profile-name-input" />
                        <Button onClick={saveProfile} disabled={saving} className="bg-cyber-purple text-white font-display" data-testid="save-profile-btn">
                            <FloppyDisk size={16} className="mr-1" />{saving ? '...' : 'Save'}
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
